var ReactRedux = require('react-redux');
var orderActions = require('../../../actions/orderActions');
var OrderStatusPresentational = require('../../../components/Admin/Orders/OrderStatus.jsx');

var mapStateToProps = function(state) {
	return state;
};

var mapDispatchToProps = function(dispatch) {
	return {
		update: function(key, data) {
			dispatch(orderActions.updateOrder(key, data));
		},

		remove: function(key, clientId) {
			dispatch(orderActions.removeOrder(key, clientId, ""));
		}
	};
};

module.exports = ReactRedux.connect(
	mapStateToProps, mapDispatchToProps
)(OrderStatusPresentational);


// WEBPACK FOOTER //
// ./src/containers/Admin/Orders/OrderStatus.js